import { useStore } from "zustand";
import { appStore } from "../store";

export const useTheme = () =>
  useStore(appStore, (state) => ({
    theme: state.theme,
    themeType: state.themeType,
  }));

export const useThemeActions = () =>
  useStore(appStore, (state) => ({
    setTheme: state.setTheme,
    setThemeType: state.setThemeType,
  }));
